<script>
  import {invertColor} from '../Common/tools';
  import {External} from "../external";

  export let id, onAction, disabled, globalStyle;

  $: {
    External.$('.floating-bar .material-icons').css('color', invertColor(globalStyle.backgroundColor || '#000000', true))
  }
</script>
<style>
  .floating-bar {
    display: none;
    position: absolute;
    top: 0px;
    right: -50px;
    width: 50px;
    padding-bottom: 80px;
  }

  .floating-bar span {
    display: block;
    cursor: pointer;
  }

  .floating-bar:hover,
  :global(table.row:hover) .floating-bar {
    display: block;
  }
</style>
{#if !disabled}
  <div class="floating-bar">
    <span class="material-icons" on:click={() => onAction(id, 'up')}>arrow_circle_up</span>
    <span class="material-icons" on:click={() => onAction(id, 'down')}>arrow_circle_down</span>
    <span class="material-icons" on:click={() => onAction(id, 'clone')}>content_copy</span>
    <span class="material-icons" on:click={() => onAction(id, 'remove')}>delete_outline</span>
  </div>
{/if}
